import { useContext, createContext } from 'react';

export const AdjustmentActionStateContext = createContext();
export const AdjustmentActionDispatchContext = createContext();

export const useAdjustmentActionStateContext = () => useContext(AdjustmentActionStateContext);
export const useAdjustmentActionDispatchContext = () => useContext(AdjustmentActionDispatchContext);
